if (!customElements.get('c2o3-notice-tooltips')) {
  customElements.define('c2o3-notice-tooltips', class extends HTMLElement {
    connectedCallback() {
      if (!('showPopover' in HTMLElement.prototype)) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.entries = [...this.querySelectorAll('details.custom-2o3-notice')].map(details => ({
        details,
        trigger: details.querySelector('summary'),
        tip: details.querySelector('[role="tooltip"]'),
      }));
      this.entries.forEach(entry => {
        entry.tip.popover = 'manual';
        Object.assign(entry.tip.style, { position: 'fixed', inset: 'auto', margin: '0', transform: 'none' });
        entry.details.addEventListener('pointerenter', event => {
          clearTimeout(this.leaveTimer);
          if (event.pointerType === 'mouse') this.show(entry);
        }, options);
        entry.details.addEventListener('pointerleave', () => this.deferClose(entry), options);
        entry.trigger.addEventListener('focus', () => this.show(entry), options);
        entry.details.addEventListener('focusout', () => this.deferClose(entry), options);
        entry.trigger.addEventListener('click', event => {
          event.preventDefault();
          if (this.active === entry && this.pinned) this.close();
          else { this.show(entry); this.pinned = true; }
        }, options);
      });
      document.addEventListener('pointerdown', event => {
        if (this.active && !this.active.details.contains(event.target)) this.close();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.active) {
          this.close();
          event.stopPropagation();
        }
      }, options);
      document.addEventListener('scroll', event => {
        if (this.active && !this.active.tip.contains(event.target)) this.schedule();
      }, { ...options, capture: true, passive: true });
      window.addEventListener('resize', () => this.schedule(), options);
      this.closest('c2o3-pill-carousel').dataset.noticesReady = 'true';
    }

    disconnectedCallback() {
      this.close();
      this.events?.abort();
      this.entries?.forEach(({ tip }) => {
        tip.removeAttribute('popover');
        tip.removeAttribute('style');
      });
      delete this.closest('c2o3-pill-carousel')?.dataset.noticesReady;
    }

    show(entry) {
      clearTimeout(this.leaveTimer);
      if (this.active === entry) return;
      this.close();
      this.active = entry;
      entry.details.open = true;
      entry.tip.showPopover();
      this.position();
    }

    close() {
      clearTimeout(this.leaveTimer);
      cancelAnimationFrame(this.frame);
      if (this.active) {
        this.active.tip.hidePopover();
        this.active.details.open = false;
      }
      this.active = null;
      this.pinned = false;
    }

    deferClose(entry) {
      clearTimeout(this.leaveTimer);
      this.leaveTimer = setTimeout(() => {
        if (!this.pinned && this.active === entry && !entry.details.matches(':hover, :focus-within')) this.close();
      }, 150);
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.position());
    }

    position() {
      if (!this.active) return;
      const { trigger, tip } = this.active;
      const anchor = trigger.getBoundingClientRect();
      const viewport = this.closest('[data-pill-viewport]').getBoundingClientRect();
      if (anchor.right <= viewport.left || anchor.left >= viewport.right || anchor.bottom < 0 || anchor.top > innerHeight) {
        this.close();
        return;
      }
      const width = tip.offsetWidth;
      const height = tip.offsetHeight;
      let left = anchor.left;
      if (this.dataset.alignment === 'center') left += (anchor.width - width) / 2;
      else if (this.dataset.alignment === 'right') left = anchor.right - width;
      let top = this.dataset.tooltipPosition === 'bottom' ? anchor.bottom + 10 : anchor.top - height - 10;
      if (top < 16) top = anchor.bottom + 10;
      else if (top + height > innerHeight - 16) top = anchor.top - height - 10;
      tip.style.left = `${Math.max(16, Math.min(left, innerWidth - width - 16))}px`;
      tip.style.top = `${Math.max(16, Math.min(top, innerHeight - height - 16))}px`;
    }
  });
}
